module.exports = __webpack_public_path__ + "img/Welcome4.60587316.png";